import React from 'react';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';


const DateRangePicker = ({ dateRange, onChange }) => {
  const presets = [
    { id: 'monthly', label: 'Monthly', icon: 'Calendar' },
    { id: 'quarterly', label: 'Quarterly', icon: 'CalendarRange' },
    { id: 'annual', label: 'Annual', icon: 'CalendarDays' },
    { id: 'custom', label: 'Custom', icon: 'CalendarClock' }
  ];

  const handlePresetChange = (presetId) => {
    const today = new Date();
    let startDate = '';
    let endDate = today?.toISOString()?.split('T')?.[0];

    if (presetId === 'monthly') {
      const firstDay = new Date(today?.getFullYear(), today?.getMonth(), 1);
      startDate = firstDay?.toISOString()?.split('T')?.[0];
    } else if (presetId === 'quarterly') {
      const quarter = Math.floor(today?.getMonth() / 3);
      const firstDay = new Date(today?.getFullYear(), quarter * 3, 1);
      startDate = firstDay?.toISOString()?.split('T')?.[0];
    } else if (presetId === 'annual') {
      const firstDay = new Date(today?.getFullYear(), 0, 1);
      startDate = firstDay?.toISOString()?.split('T')?.[0];
    }

    onChange({
      ...dateRange,
      preset: presetId,
      startDate: presetId === 'custom' ? dateRange?.startDate : startDate,
      endDate: presetId === 'custom' ? dateRange?.endDate : endDate
    });
  };

  const handleFiscalYearAlignment = () => {
    const today = new Date();
    const fiscalYearStart = new Date(today?.getFullYear(), 0, 1);
    const fiscalYearEnd = new Date(today?.getFullYear(), 11, 31);

    onChange({
      ...dateRange,
      preset: 'custom',
      startDate: fiscalYearStart?.toISOString()?.split('T')?.[0],
      endDate: fiscalYearEnd?.toISOString()?.split('T')?.[0]
    });
  };

  return (
    <div>
      <label className="block text-sm font-medium text-foreground mb-3">
        Report Period
      </label>

      <div className="grid grid-cols-2 gap-2 mb-4">
        {presets?.map((preset) => (
          <Button
            key={preset?.id}
            variant={dateRange?.preset === preset?.id ? 'primary' : 'outline'}
            size="sm"
            iconName={preset?.icon}
            onClick={() => handlePresetChange(preset?.id)}
          >
            {preset?.label}
          </Button>
        ))}
      </div>

      <div className="space-y-3">
        <Input
          type="date"
          label="Start Date"
          value={dateRange?.startDate}
          onChange={(e) => onChange({ ...dateRange, startDate: e?.target?.value, preset: 'custom' })}
        />
        <Input
          type="date"
          label="End Date"
          value={dateRange?.endDate}
          onChange={(e) => onChange({ ...dateRange, endDate: e?.target?.value, preset: 'custom' })}
        />
      </div>

      <Button
        variant="ghost"
        size="sm"
        iconName="CalendarCheck"
        onClick={handleFiscalYearAlignment}
        className="mt-3 w-full"
      >
        Align to Fiscal Year
      </Button>
    </div>
  );
};

export default DateRangePicker;